import APIV3 from '../../../api/axios/APIV3';

export const fetchSearchedCategories = async (keyword, languageId) => {
    const response = await APIV3.get(
        `restaurants/:restaurantId/categories/internal-name?language_id=${languageId}&keyword=${keyword}`
    );

    return response;
};
